import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Home from '../pages/Home';
import AboutUs from '../pages/AboutUs';
import WhoIsChaitralee from '../pages/WhoIsChaitralee';
import ChaitraleeActivities from '../pages/ChaitraleeActivities';
import OurActivities from '../pages/OurActivities';
import OurGoal from '../pages/OurGoal';
import OurTeam from '../pages/OurTeam';
import YouCan from '../pages/YouCan';
import ContactUs from '../pages/ContactUs';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<MainLayout />}>
      <Route index element={<Home />} />
      <Route path="about" element={<AboutUs />} />
      <Route path="who-is-chaitralee" element={<WhoIsChaitralee />} />
      <Route path="chaitralee-world" element={<ChaitraleeActivities />} />
      <Route path="our-activities" element={<OurActivities />} />
      <Route path="our-goal" element={<OurGoal />} />
      <Route path="our-team" element={<OurTeam />} />
      <Route path="you-can" element={<YouCan />} />
      <Route path="contact" element={<ContactUs />} />
    </Route>
  </Routes>
);

export default AppRoutes;
